/* eslint-disable no-restricted-globals */
/* eslint-disable no-useless-escape */

import React from "react";
import PublicationLinks from "../Publications/components/PublicationLinks";
import Linkify from "../atoms/Linkify";
import DangerousHtml from "../atoms/DangerousHtml";

const OMIM_SIMPLE_LINK_REGEX = /{[\d+.]+}/gm; // matches everything inside square brackets that containis numbers and .{}
const PUBLICATIONS_REGEX = new RegExp(/{([\d,]+):.*?}/, "gm"); // example match {81:Rijntjes-Jacobs et al. (2010)}
const OMIM_PATH_TO_REGEX = /{([a-zA-Z]+[\s]*[0-9.]+?)}/gm;

const PUBLICATION_EXTRACTOR = /^[^\(^\)]*(\d+)/;
const INFORMATION_EXTRACTOR = /{([^)]+)}/;
const USED_NAME_EXTRACTOR = /([a-zA-z\s']+[.,\s\((\d+)]*)/;

const PATH_EXTRACTOR = /[a-zA-Z]+/;
const PATH_VALUE_EXTRACTOR = /[0-9.]+/;

export const omimStringTransformer = (rawOmimText, references) => {
  if (!rawOmimText) return null;
  // Accepts an input text and returns a transformed result
  // with the found links
  const foundsLinks = rawOmimText.match(OMIM_SIMPLE_LINK_REGEX);
  let cpy = rawOmimText;
  foundsLinks?.forEach((link) => {
    if (link) {
      const extractedValue = INFORMATION_EXTRACTOR.exec(link)?.[1];
      const finalValue = extractedValue?.replaceAll(".", "#");
      if (finalValue) {
        cpy = cpy.replaceAll(
          link,
          `<a href=https://omim.org/entry/${finalValue} target="_blank">${extractedValue}</a>`
        );
      }
    }
  });

  const foundLinksContainingPaths = cpy.match(OMIM_PATH_TO_REGEX);
  foundLinksContainingPaths?.forEach((link) => {
    if (link) {
      const path = PATH_EXTRACTOR.exec(link)?.[0];

      const extractedValue = PATH_VALUE_EXTRACTOR.exec(link)?.[0];
      if (extractedValue && path) {
        cpy = cpy.replaceAll(
          link,
          `<a href=https://enzyme.expasy.org/${path}/${extractedValue} target="_blank">${path} ${extractedValue}</a>`
        );
      }
    }
  });

  // End of OMIM URL REPLACEMENT

  if (!references?.length) return <DangerousHtml str={cpy} isDirty={false} />;
  const conf = [
    {
      regexMatch: PUBLICATIONS_REGEX,
      // eslint-disable-next-line react/prop-types
      Renderer: ({ match }) => {
        const pubIdMatch = PUBLICATION_EXTRACTOR.exec(match)?.[0];
        const textUsed = USED_NAME_EXTRACTOR.exec(match)?.[0];
        if (pubIdMatch) {
          const clearPubId = pubIdMatch.replace("{", "");
          // Handle multiple publication ids.
          if (
            clearPubId.includes(",") &&
            clearPubId.split(",").every((x) => !isNaN(x))
          ) {
            const ids = clearPubId.split(",");
            const existingIds = ids
              .map((pubId) => {
                const pubmedId = references.filter(
                  (ref) => ref?.reference_number === parseInt(pubId, 10)
                )[0]?.pub_med_references?.[0];
                return pubmedId;
              })
              .filter((x) => Boolean(x));

            return existingIds.length ? (
              <PublicationLinks ids={existingIds} />
            ) : null;
          }
          // Handle single publications ids
          const pubmedId = references.filter(
            (ref) => ref?.reference_number === parseInt(clearPubId, 10)
          )[0]?.pub_med_references?.[0];
          return pubmedId ? (
            <PublicationLinks ids={[pubmedId]}>
              <div>
                {textUsed || "PubMed:"} {pubmedId}
              </div>
            </PublicationLinks>
          ) : null;
        }
        return textUsed;
      },
    },
  ];
  return <Linkify text={cpy} isHtml={true} conf={conf} isHtmlDirty={false} />;
};

export const OMIM_MAPPINGS = {
  1: "The disorder is placed on the map based on its association with a gene, but the underlying defect is not known.",
  2: "The disorder has been placed on the map by linkage; no mutation has been found",
  3: "The molecular basis for the disorder is known; a mutation has been found in the gene",
  4: "A contiguous gene deletion or duplication syndrome, multiple genes are deleted or duplicated causing the phenotype",
};

export const NUMBER_OF_PHENOTYPES = 2;
